import { useCallback, useRef } from 'react'

interface FontCache {
  [fontFamily: string]: boolean
}

export function useDynamicFontLoading() {
  const loadedFonts = useRef<FontCache>({})

  const loadGoogleFont = useCallback((fontName: string) => {
    if (loadedFonts.current[fontName]) return

    const link = document.createElement('link')
    link.href = `https://fonts.googleapis.com/css2?family=${fontName.replace(/ /g, '+')}&display=swap`
    link.rel = 'stylesheet'
    document.head.appendChild(link)

    loadedFonts.current[fontName] = true
  }, [])

  return { loadGoogleFont }
}
